import React, {useContext} from 'react'
import {Link} from 'react-router-dom'

import DispatchContext from '../../DispatchContext'
import StateContext from '../../StateContext'
import {
    MDBNavbarNav, MDBNavItem, 
    MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon
    } from "mdbreact";

function HeaderLoggedIn(props) {

    const appDispatch = useContext(DispatchContext)
    const appState = useContext(StateContext)

    function logOut() {
        appDispatch({type: "logout"})
        appDispatch({type: "flashMessage", value: "Du har blitt logget ut!"});
    }
    

    return (
        <MDBNavbarNav right>

            

            <MDBNavItem >
                <MDBDropdown>
                    <MDBDropdownToggle nav caret>
                    <MDBIcon icon="user" />
                    </MDBDropdownToggle>
                        <MDBDropdownMenu onClick={() => props.setIsOpen(false)} className="dropdown-default">
                            <MDBDropdownItem><Link to={"/member/" + appState.userId}>Din profil</Link></MDBDropdownItem>
                    </MDBDropdownMenu>
                </MDBDropdown>
            </MDBNavItem>
            <button onClick={logOut} className="btn btn-sm btn-danger btn-rounded">
                Logg ut
          </button>
        </MDBNavbarNav>
    )

}
export default HeaderLoggedIn